// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const DropdownDownHover: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 15 8"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="15"
            height="8"
            fill="currentColor"
        >
            <path
                d="M352.082031,184.996094 L346.144531,190.585938 C345.964844,190.789062 345.730469,190.875 345.5,190.875 C345.269531,190.875 345.035937,190.789532 344.855469,190.618671 L338.917969,184.996094 C338.541797,184.636719 338.526172,184.042969 338.88125,183.667969 C339.237891,183.289062 339.833594,183.277344 340.207031,183.632813 L345.5,188.644531 L350.792969,183.628906 C351.166485,183.273672 351.759766,183.287109 352.11875,183.665527 C352.472656,184.042969 352.457031,184.636719 352.082031,184.996094 Z"
                transform="translate(-338 -183)"
            />
        </svg>
    );
};

export default React.memo(DropdownDownHover);
